import React from 'react';

// const BIHAR_IMAGE = 'https://placehold.co/500x400/1e3a5f/ffffff?text=About+Bihar';
import biharImage from "../assets/images/bihar_img_4.avif";

function AboutBiharSection() {
  return (
    <section id="about-bihar" className="section about-bihar-section president-section">
      <div className="container">
        <div className="president-grid">
          <div className="president-media">
            <div className="president-image-wrap">
              <img src={biharImage} alt="Bihar" className="president-image" />
            </div>
            {/* <p className="president-caption">About Bihar</p> */}
          </div>
          <div className="president-content">
            <h2 className="president-title">About Bihar</h2>
            <div className="president-body">
              <p>
                Bihar, steeped in the rich tapestry of Indian history, has been home to some of the most influential figures shaping the cultural and intellectual landscape of the subcontinent. Ashoka, the Mauryan emperor, stands as a beacon of peace and governance, his reign marked by the spread of Buddhism and the edicts of tolerance etched onto stone pillars across the land. Chandragupta Maurya, his predecessor, laid the foundation of one of India's greatest empires, heralding an era of political consolidation and administrative innovation.
              </p>
              <p>
                Aryabhata, the revered mathematician and astronomer, hailed from the fertile plains of Bihar, pioneering groundbreaking theories that revolutionized ancient Indian mathematics and astronomy. Balmiki, the sage-poet, composed the epic Ramayana, a timeless saga woven with moral lessons and divine wisdom. Nalanda University, a bastion of learning and intellectual exchange, flourished as a center of Buddhist studies and attracted scholars from far and wide, contributing to the dissemination of knowledge across the region.
              </p>
              <p>
                Vikramshila, another renowned center of learning, fostered the development of Buddhist philosophy and logic, leaving an indelible mark on the intellectual history of the region. Together, these figures and institutions form the vibrant mosaic of Bihar's historical legacy, a testament to its enduring cultural and intellectual heritage.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutBiharSection;
